import React from "react";

export const useCheckboxMapHandler = (initialState: any) => {
  const [checkboxItems, setCheckbox] = React.useState(initialState);

  const handleChange = React.useCallback(({ target: { name, checked } }) => {
    setCheckbox((prevState: Iterable<readonly [unknown, unknown]> | null | undefined) => {
      return new Map(prevState).set(name, checked);
    });
  }, []);

  const resetValues = React.useCallback(() => setCheckbox(initialState), [
    initialState
  ]);

  return {
    checkboxItems,
    handleChange,
    resetValues
  };
};


const dataInitial = (data) => {
  const arr = [...data];
  return arr.map((item) => {
    return {
      ...item, checked: false
    }
  });
}

export const useCheckboxHandler = (initialState: any) => {
  const [checkboxes, setCheckbox] = React.useState(initialState);

  React.useEffect(() => {
    setCheckbox(initialState);
  }, [initialState])

  const handleEventChange = React.useCallback(({ target: { name } }) => {
    setCheckbox((prevState: any[]) =>
      prevState.map((item: { name: any; checked: any; }) =>
        item.name === name ? { ...item, checked: !item.checked } : { ...item }
      )
    );
  }, []);

  const resetCheckboxValues = React.useCallback(() => setCheckbox(dataInitial(initialState)), [
    initialState
  ]);

  return {
    handleEventChange,
    resetCheckboxValues,
    checkboxes
  };
};
